import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
} from '@chakra-ui/react';
import { FC, memo, useEffect } from 'react';

import {
  containterStyle,
  layoutStyled,
} from '@components/Layout/Layout.styles';
import { ILayout } from '@components/Layout/Layout.types';
import Navbar from '@components/Navbar';
import RenderIf from '@components/RenderIf';
import SEO from '@components/Seo/Seo';
import Sidebar from '@components/Sidebar';
import useResponsive from '@hooks/useResponsive';
import { useRouter } from 'next/router';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { sidebarIsOpen } from 'store/Common';

const Layout: FC<ILayout> = ({
  children,
  title,
  description,
  imageUrl,
  urlCanonical,
  menuSelected,
  isAuthLayout,
  ...props
}): JSX.Element => {
  const isOpenSidebar = useRecoilValue(sidebarIsOpen);
  const setSidebarOpen = useSetRecoilState(sidebarIsOpen);
  const router = useRouter();
  const { isTablet } = useResponsive();

  useEffect(() => {
    if (isTablet) {
      setSidebarOpen(false);
    }
  }, [router, isTablet]);

  return (
    <>
      <SEO
        title={title}
        description={description}
        imageUrl={imageUrl}
        urlCanonical={urlCanonical}
        type="website"
      />
      <Box {...containterStyle} {...props}>
        <RenderIf isTrue={!isAuthLayout}>
          <Sidebar
            menuSelected={menuSelected}
            display={{ base: 'none', lg: 'block' }}
          />
        </RenderIf>
        {!isAuthLayout && isTablet && (
          <Drawer
            isOpen={isOpenSidebar}
            placement="left"
            onClose={() => setSidebarOpen(false)}
          >
            <DrawerOverlay />
            <DrawerContent p="0" maxW="270px">
              <DrawerBody p="0">
                <Sidebar menuSelected={menuSelected} w="full" />
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        )}
        <Box {...layoutStyled()}>
          <RenderIf isTrue={!isAuthLayout}>
            <Navbar />
          </RenderIf>
          <Box
            as="main"
            id="container"
            p="4"
            pos="relative"
            {...(isAuthLayout && { p: 0 })}
            zIndex="1"
          >
            {children}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default memo(Layout);
